import { api } from '../axiosClient';
import { type RawTypesenseAPIKeys } from './typeSenseAPIKeys.types';

const TYPESENSE_API_KEYS_PATH = '/Search/token';

export const getTypeSenseAPIKeys = (): Promise<RawTypesenseAPIKeys> => {
  return api.get(TYPESENSE_API_KEYS_PATH);
};
